import React from 'react';
import { Button } from '@mui/material';
import Iconify from '@/components//Iconify';

function TicketArrow({ onClick = () => {}, disabled = false }) {
  return (
    <Button
      disabled={disabled}
      sx={{
        backgroundColor: (theme) => theme.palette.primary.palette[50],
        display: 'flex',
        alignItems: 'center',
        pb: 1,
        padding: 0,
        ml: 1,
        border: (theme) => `0.5px solid ${theme.palette.primary.palette[100]}`,
        borderRadius: '4px',
        minWidth: '8px',
      }}
      onClick={onClick}
    >
      <Iconify width={20} height={20} icon={'mdi:keyboard-arrow-right'} />
    </Button>
  );
}

export default TicketArrow;
